module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Gd-Ha-Id-Ja.67c0946a.png";